import { AjaxPageHandler } from './misc/Ajax';
import jQuery from "jquery";

import { gsap } from 'gsap';
import { imagesLoaded } from 'imagesloaded';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin.js';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';


/* Page handlers */
import { AboutPageHandler } from './pages/About';
import { HomePageHandler } from './pages/Home';
import { HomeNewPageHandler } from './pages/HomeNew';
import { ContactPageHandler } from './pages/Contact';
import { ProjectPageHandler } from './pages/Project';
import { DesignPageHandler } from './pages/Design';
import { SinglePageHandler } from './pages/Single';
import { PageHandler } from './pages/PageHandler';
import { MenuHandler } from './misc/Menu';
import { PVOutputPageHandler } from './pages/PVOutput';


class SiteHandler {
	constructor() {
		this.pageHandlers = [
			/* Main pages */
			{ name: 'homePageHandler', class: HomePageHandler, id: 'home' },
			{ name: 'homeNewPageHandler', class: HomeNewPageHandler, id: 'home-new' },
			{ name: 'designPageHandler', class: DesignPageHandler, id: 'design' },
			{ name: 'pvOutputPageHandler', class: PVOutputPageHandler, id: 'pv-analysis' },
			{ name: 'aboutPageHandler', class: AboutPageHandler, id: 'about' },
			{ name: 'contactPageHandler', class: ContactPageHandler, id: 'contact' },
			{ name: 'projectPageHandler', class: ProjectPageHandler, id: 'project' },
			/* Generic Pages stuff */
			{ name: 'termsofusePageHandler', class: SinglePageHandler, id: 'terms-of-use' },
			{ name: 'privacyPageHandler', class: SinglePageHandler, id: 'privacy-policy' },
		];
		this.objectHandlers = [
			{ name: 'primaryMenuHandler', class: MenuHandler, id: 'primary-menu' },
		];
	}

	getPageHandler(id) {
		var handler = this.pageHandlers.filter((handler) => handler.id === id)[0];
		return handler ? window[handler.name] : null;
	}

	getObjectHandler(id) {
		var handler = this.objectHandlers.filter((handler) => handler.id === id)[0];
		return handler ? window[handler.name] : null;
	}

	initHandlers() {
		this.pageHandlers.forEach((handler, index) => {
			window[handler.name] = new (handler.class)(handler.id);
		})
		this.objectHandlers.forEach((handler, index) => {
			window[handler.name] = new (handler.class)(handler.id);
		})
	}

	closeMobMenu() {

	}

	initSelect(elem, callback) {
		const selectWrapper = document.querySelector(elem);
		const select = selectWrapper.querySelector('.custom-select');
		const selectItems = selectWrapper.querySelector('.select-items');
		const selectSelected = selectWrapper.querySelector('.select-selected');

		selectSelected.addEventListener('click', function () {
			selectItems.classList.toggle('select-hide');
		});

		selectWrapper.querySelectorAll('.select-option').forEach(option => {
			option.addEventListener('click', function () {
				const text = this.innerText;
				selectSelected.innerText = text;
				selectWrapper.querySelectorAll('.select-option').forEach(option => {
					option.classList.remove('same-as-selected');
				});
				this.classList.add('same-as-selected');
				selectItems.classList.add('select-hide');
				if (typeof callback === 'function') 
					callback(option);
			});
		});

		document.addEventListener('click', function (event) {
			if (!selectWrapper.contains(event.target))
				selectItems.style.display = 'none'; // Hide the dropdown if clicking outside
			else if (event.target === selectSelected || select.contains(event.target))
				selectItems.style.display = selectItems.style.display === 'block' ? 'none' : 'block'; // Toggle the dropdown
		});
	}

	events() {
		jQuery('.disabled a[href^="#"], .expand a[href^="#"]').on('click', function(e) {
			e.preventDefault();
		})
		
		jQuery('.main-navigation:not(#mob-site-navigation) .menu-item-has-children:not(.no-click) > a').on('click', function(e) {
			e.stopPropagation();
			e.preventDefault();
			if ('ontouchstart' in window || navigator.msMaxTouchPoints)
			{
				jQuery(this).siblings('.sub-menu').toggleClass('show') // Toggle the submenu visibility on click
				return;
			}
			else
			{
				window.leaving = true;
				if (!e.target.href)
					ajaxPH.maskOn(() => { window.location.href = '/'; });
				else
					ajaxPH.maskOn(() => { window.location.href = e.target.href });
			}
		});


		jQuery('body').on('click', `.main-navigation li:not(.disabled):not(.menu-item-has-children) a[target!='_blank'], 
		button a[target!='_blank'], 
		.polylang_langswitcher a[target!='_blank'],
		footer li a[target!='_blank'], 
		.site-branding a[target!='_blank'], 
		.filter a,
		.go-to-all a,
		.back-to-news a,
		.back-to-team a,
		.section__team-member-link,
		.section__page-hero a,
		article a[target!='_blank'],
		.mob-menu-overlay li:not(.menu-item-has-children):not(.go-back) a[target!='_blank']`, function(e) {
			e.stopPropagation();
			e.preventDefault();
			window.leaving = true;
			if (!e.target.href)
				ajaxPH.maskOn(() => { window.location.href = '/'; });
			else
				ajaxPH.maskOn(() => { window.location.href = e.target.href });
		})

		/* Mobile menu */
		if (0)
		{
			jQuery('.main-navigation__lines').on('click', function () {
				var me = jQuery(this);
				var openClass = 'main-navigation__lines--open';
				me.toggleClass(openClass);
				if (me.hasClass(openClass)) {
					gsap.set('body, html', {overflow: "hidden", height: "100%"})
					gsap.to('.mob-menu-overlay', {
						duration: 0.3,
						autoAlpha: 1,
						ease: 'power1.inOut'
					});
				} else {
					gsap.set('body, html', {overflow: "unset", height: 'auto'})
					gsap.to('.mob-menu-overlay', {
						duration: 0.3,
						autoAlpha: 0,
						ease: 'power1.inOut'
					});
				}
			});
		}

		/* Scroll header */
		var lastScrollTop = 0;
	
		function hasScrolled() {
			var st = window.scrollY || document.documentElement.scrollTop;

			var $header = jQuery("header.site-header");
			if (window.innerWidth < 768)
				return;
			if (st <= $header.outerHeight()) {
				$header.removeClass("scrolled");
				$header.removeClass("not-at-top");
				return;
			}

			$header.addClass("not-at-top");
			if (st > lastScrollTop){
				// Scroll Down
				$header.addClass("scrolled");
			} else {
				// Scroll Up
				$header.removeClass("scrolled");
			}
	
			
			lastScrollTop = st;
		}
		jQuery(window).on('scroll', hasScrolled);
		hasScrolled();
	}

	init() {
		gsap.registerPlugin(ScrollTrigger);
		gsap.registerPlugin(ScrollToPlugin);

		this.initHandlers();
		this.events();
	}

	runRCModel(rcdata) {
		jQuery.ajax({
            url: bipv_script_data.ajax_url,
            type: 'GET',
            dataType: 'json',
            data: {
				action: "rc_model_request",
				_ajax_nonce_rc: bipv_script_data.nonce_rc,
				data: rcdata
			},
            success: (response) => {
				console.log(response)
            },
            error: function(xhr, status, error) {
                console.error('AJAX Error:', status, error);
            }
        });
	}

	destroy() {

	}

	transitions () {
		
	}
}

	
(function($) {
	$(function() {
		window.global = new SiteHandler();
		window.global.init();
		window.ajaxPH = new AjaxPageHandler();
		ajaxPH.init();
		
		const main = document.querySelector('main');
		if (main && window.global.getPageHandler(main.id)) {
			window.global.getPageHandler(main.id).init();
		}
		ajaxPH.maskOff(() => {
			if (main && window.global.getPageHandler(main.id)) {
				window.global.getPageHandler(main.id).transitions();
				window.global.transitions();
			}
		});

		window.global.getObjectHandler('primary-menu').init();
		gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

		document.addEventListener('visibilitychange', function() {
			if (document.visibilityState === 'visible' && window.leaving) {
				ajaxPH.maskOff();
			}
		});
	})
}(jQuery));